<template>
  <ul class="grid">
    <slot />
  </ul>
</template>
<script lang="ts" setup></script>
<style lang="scss" scoped>
.grid {
  display: grid;
  grid-auto-rows: 1fr;
  grid-template-columns: repeat(auto-fill, minmax(14rem, 1fr));
  @include above('m') {
    grid-template-columns: repeat(auto-fill, minmax(18rem, 1fr));
  }

  width: 100%;
  gap: var(--gap_l);

  :deep(li .card) {
    height: 100%;
  }
}
</style>
